import { render } from "./JournalTopics.vue?vue&type=template&id=ad76e472"
import script from "./JournalTopics.vue?vue&type=script&lang=js"
export * from "./JournalTopics.vue?vue&type=script&lang=js"

import exportComponent from "/srv/data/www/krasp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/JournalTopics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ad76e472"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ad76e472', __exports__)) {
    api.reload('ad76e472', __exports__)
  }
  
  module.hot.accept("./JournalTopics.vue?vue&type=template&id=ad76e472", () => {
    api.rerender('ad76e472', render)
  })

}


export default __exports__